import React, { useEffect } from 'react';
import { Paper, Typography, CircularProgress } from '@material-ui/core';
import { get } from '../../utils/network';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import version from '../../version'
const HealthStatus = () => {

  const [ status, setStatus ] = React.useState(null)

  useEffect(() => {
    get('dev/status')
      .then(res => res.json())
      .then(res => {
        console.log(res.message)
        setStatus(res.message)
      })
      .catch(err => console.log(err))
  }, [])

  return (
    <Paper style={{ padding: '1rem', width: '30%' }}>
      <div>
        <div>
            <Typography style={{ fontSize: 20 }}>Version:</Typography>
        </div>
        {status ? <>
          <p>API:  {status.Version}</p>
          <p>Cliente:  {version.version}</p>
        </> : <div style={{display: 'flex', alignItems: 'center'}}><CircularProgress size={20} style={{ padding:'0.25rem'}}/>Cargando...</div> }
      </div>
      <div>
        <div>
            <Typography style={{ fontSize: 20 }}>Estado de los servicios:</Typography>
        </div>
        {status ? <>
          <div style={{ display: 'flex', alignItems: 'center'}}><p style={{marginRight: '0.25rem'}}>DocumentDB</p>{status?.DocumentDB === 'ok' ? <CheckCircleIcon style={{color: 'green'}}/> : <ErrorIcon style={{color: 'red'}}/>}</ div>
          <div style={{ display: 'flex', alignItems: 'center'}}><p style={{marginRight: '0.25rem'}}>S3</p>{status?.S3 === 'ok' ? <CheckCircleIcon style={{color: 'green'}}/> : <ErrorIcon style={{color: 'red'}}/>}</ div>
          <div style={{ display: 'flex', alignItems: 'center'}}><p style={{marginRight: '0.25rem'}}>OpenSearch</p>{status?.OpenSearch === 'ok' ? <CheckCircleIcon style={{color: 'green'}}/> : <ErrorIcon style={{color: 'red'}}/>}</ div>
        </> : <div style={{display: 'flex', alignItems: 'center'}}><CircularProgress size={20} style={{ padding:'0.25rem'}}/>Cargando...</div> }
      </div>
    </Paper>
  )
}

export default HealthStatus